const subscriptions = {};

const subscribe = (eventName, callback) => {
  console.log(`[eventBus] ${eventName} new subscribe`);
  if (!subscriptions[eventName]) {
    subscriptions[eventName] = new Set();
  }

  const callbacks = subscriptions[eventName];
  callbacks.add(callback);

  // unsubscribe
  return () => {
    console.log(`[eventBus] ${eventName} unsubscribe`);
    callbacks.delete(callback);

    if (callbacks.size === 0) {
      delete subscriptions[eventName];
    }
  };
};

const emit = (eventName, ...args) => {
  if (!subscriptions[eventName]) return;

  console.log(`[eventBus] ${eventName} emitted`);

  const callbacks = subscriptions[eventName];

  for (const callback of callbacks) {
    callback(...args);
  }
};

const eventBus = {
  subscribe,
  emit,
};

export default eventBus;
